import styles from './name-and-comment.module.less';
import ButtonText from '../../../components/button/button-text/ButtonText';
import Chevron from '../../../components/chevron/Chevron';
import NameAndComment from './NameAndComment';
import { useProject } from '../../project-hooks/useProject';
import { useState } from 'react';
import I18nText from '../../i18n/I18nText';
import { NAME_AND_COMMENT_TEXT_KEY } from '../../i18n/project-i18n-model';

export const NameAndCommentContainer = ({ giverName, setGiverName, comment, setComment, className, isOpen }) => {
    const project = useProject();
    const [showNameAndComment, setShowNameAndComment] = useState(isOpen);

    if (project.profile?.anonymousGiver) {
        return null;
    }
    return (
        <div className={styles.giverNameContainer}>
            {!showNameAndComment && (
                <ButtonText
                    onClick={() => setShowNameAndComment(!showNameAndComment)}
                    trackingCategory="show-name-and-comment"
                    trackingAction="click"
                >
                    <I18nText textKey={NAME_AND_COMMENT_TEXT_KEY} /> <Chevron isOpen={showNameAndComment} />
                </ButtonText>
            )}
            {showNameAndComment && (
                <NameAndComment
                    className={className}
                    name={giverName}
                    setName={(name) => setGiverName(name)}
                    comment={comment}
                    setComment={(c) => setComment(c)}
                />
            )}
        </div>
    );
};
